export default __webpack_public_path__ + "static/media/work-1.d83213f6.png";